const FETCH_KNOWLEDGE_QUESTION_SET = 'FETCH_KNOWLEDGE_QUESTION_SET'
export const FETCH_KNOWLEDGE_QUESTION_SET_SUCCESS = `${FETCH_KNOWLEDGE_QUESTION_SET}_SUCCESS`
export const FETCH_KNOWLEDGE_QUESTION_SETS = 'FETCH_KNOWLEDGE_QUESTION_SETS'
export const FETCH_KNOWLEDGE_QUESTION_SETS_SUCCESS = `${FETCH_KNOWLEDGE_QUESTION_SETS}_SUCCESS`

export const FETCH_KNOWLEDGE_QUESTION_SETS_NO_LOADER = 'FETCH_KNOWLEDGE_QUESTION_SETS_NO_LOADER'
export const FETCH_KNOWLEDGE_QUESTION_SETS_NO_LOADER_SUCCESS = `${FETCH_KNOWLEDGE_QUESTION_SETS_NO_LOADER}_SUCCESS`
export const UPDATE_QUESTION_SET = 'UPDATE_QUESTION_SET'
export const UPDATE_QUESTION_SETS_TO_PUBLISH = 'UPDATE_QUESTION_SETS_TO_PUBLISH'
export const SAVE_QUESTION_SET = 'SAVE_QUESTION_SET'
export const RESET_QUESTION_SET = 'RESET_QUESTION_SET'
export const CLEAR_CREATED_QUESTION_SET = 'CLEAR_CREATED_QUESTION_SET'

export const SAVE_DRAFT_QUESTION_SET = 'SAVE_DRAFT_QUESTION_SET'
export const SAVE_PUBLISH_QUESTION_SET = 'SAVE_PUBLISH_QUESTION_SET'
export const SAVE_DRAFT_QUESTION_SET_SUCCESS = `${SAVE_DRAFT_QUESTION_SET}_SUCCESS`
export const SAVE_PUBLISH_QUESTION_SET_SUCCESS = `${SAVE_PUBLISH_QUESTION_SET}_SUCCESS`
